import { yupResolver } from '@hookform/resolvers/yup';

import {
  object, string, REQUIRED_MESSAGE, date,
} from './general';

const schema = object().shape({
  frequency: string().required(REQUIRED_MESSAGE),
  info: object().shape({
    startDate: date().required(REQUIRED_MESSAGE),
  }).required(REQUIRED_MESSAGE),
});

export default yupResolver(schema);
